import { Col, Row, Skeleton } from "antd";
import React, { FC, useEffect, useState } from "react";
import faker from "faker";


import { Students } from "../../../../models/StudentsModel/students.model";
import { useLocation } from "react-router-dom";

import PhoneIcon from "../../../../assets/icons/phone.svg";
import MailIcon from "../../../../assets/icons/mail.svg";
import CapIcon from "../../../../assets/icons/students-cap.svg";
import BlockeIcon from '../../../../assets/icons/close-red-icon.svg';

import CalendarIcon from "../../../../assets/icons/calendar.svg";

import "./details.scss";

import StudentService from "../../../../services/StudentService/student.service";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import { StudentPasswordForm } from "../../../Institute/InstituteDetails/InstituteStudents/InstituteStudentDetails/StudentPasswordForm";

export const Details: FC = () => {
  const { state }: { state: Students } = useLocation();
  const [studentDetails, setStudentDetails] = useState<Students>(state);
  const [loading, setLoading] = useState<boolean>(false);
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  
  // const fetchStudentDetails = () => {
  //   if (state?.id) {
  //     StudentService.getStudentsDetails(
  //       state?.id,
  //       (details) => {
  //         setStudentDetails(details);
  //       },
  //       () => {},
  //       () => {
  //         setLoading(false);
  //       }
  //     );
  //   }
  // };

  // useEffect(() => {
  //   fetchStudentDetails();
  // }, []);


  return (
    <div className="details__container">
      {loading ? (
        <Row gutter={16} className="details__wrapper">
          <Col span={12}>
            <Skeleton avatar paragraph={{ rows: 4 }} />
          </Col>
          <Col span={12}>
            <Skeleton avatar paragraph={{ rows: 4 }} />
          </Col>
        </Row>
      ) : (
        <Row gutter={16} className="details__wrapper">
          <Col span={12}>
            <p className="details__title">Profile details</p>
            <div className="student__details">
              <div className="student-details__wrapper">
                <div className="student-profile__wrapper">
                  {/* <img src={studentDetails?.} /> */}
                  <div className="student-name__wrapper">
                    <p className="student__name">{studentDetails?.name}</p>
                    <p>{studentDetails?.id}</p>
                  </div>
                </div>
                <Row className="student-institute-details__wrapper">
                  <Col span={8}>
                    <div className="student-instiute__details">
                      <img src={PhoneIcon} />
                      <p>{studentDetails?.phoneNumber}</p>
                    </div>
                  </Col>
                  <Col span={16}>
                    <div className="student-instiute__details">
                      <img src={MailIcon} />
                      <p>{studentDetails?.email}</p>
                    </div>
                  </Col>
                  {studentDetails?.dob && <Col span={8}>
                    <div className="student-instiute__details">
                      <img src={CalendarIcon} />
                      <p>{studentDetails?.dob}</p>
                    </div>
                  </Col>
                  }
                  {studentDetails?.isBlocked && (
                    <Col span={16}>
                      <div className='student-instiute__details'>
                        <img src={BlockeIcon} />
                        <p>{studentDetails?.blockedReason}</p>
                      </div>
                    </Col>
                  )}
                </Row>
                
                <Row className='student-institute-details__wrapper'>
                  <Col span={8}>
                    <ButtonComponent
                      className='header-add-btn'
                      buttonContent={'Update Password'}
                      type='primary'
                      onClick={() => {
                        setShowDrawer(true);
                      }}
                    />
                  </Col>
                  <StudentPasswordForm
                    open={showDrawer}
                    setOpen={setShowDrawer}
                    onClose={() => setShowDrawer(false)}
                    studentData={studentDetails}
                  />
                </Row>
              </div>
            </div>
          </Col>

        </Row>
      )}
    </div>
  );
};
